import React, { forwardRef, useMemo } from 'react';
import block from 'bem-cn';
import DatePicker from 'react-datepicker';

import SVG from 'components/SVG';

import { formateDate } from 'shared/helpers';

import calendarSVG from './img/calendar.svg';
import calendarGraySVG from './img/calendar-gray.svg';

import arrowSVG from './img/arrow.svg';

import 'react-datepicker/dist/react-datepicker.css';

import './InputDate.scss';

const b = block('input-date-desktop');

const InputDate = ({
  dateFormat = 'yyyy-MM-dd',
  selected,
  isValid,
  onChange,
  color,
  withManualTyping = false,
  disabled = false,
  showTimeSelect = false,
  fontSize,
  withoutFormatting,
  title,
}) => {
  const calendarIMG = color === 'gray' ? calendarGraySVG : calendarSVG;

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className={b('custom-date-input', { color })} onClick={onClick} ref={ref}>
      <div className={b('custom-date-input-left')}>
        <SVG className={b('custom-date-input-calendar', { small: Boolean(title) })} svgProps={{ svg: calendarIMG }} />
        <div className={b('custom-date-input-container')}>
          <span className={b('custom-date-input-title')}>{title}</span>
          <span className={b('custom-date-input-value', { fontSize })}>
            {withoutFormatting ? value : formateDate(value)}
          </span>
        </div>
      </div>

      {!disabled && (
        <SVG className={b('custom-date-input-arrow', { small: Boolean(title) })} svgProps={{ svg: arrowSVG }} />
      )}
    </div>
  ));

  const validState = useMemo(() => {
    if (String(selected).length === 0 || isValid === undefined) return 1;
    if (isValid) return 2;
    return 3;
  }, [isValid, selected]);

  return (
    <label className={b({ validState, color, withManualTyping, disabled })}>
      <input
        className={b('input')}
        /* для связки с формой, что бы при нажатии enter на клавиатуре тригерился сабмит формы при изменении датапикера */
      />
      {withManualTyping ? (
        <div className={b('custom-date-input')}>
          <SVG className={b('custom-date-input-calendar')} svgProps={{ svg: calendarIMG }} />
          <DatePicker
            calendarStartDay={1}
            disabled={disabled}
            selected={selected}
            onChange={onChange}
            dateFormat={dateFormat}
          />
          {!disabled && <SVG className={b('custom-date-input-arrow')} svgProps={{ svg: arrowSVG }} />}
        </div>
      ) : (
        <DatePicker
          showTimeSelect={showTimeSelect}
          dateFormat={dateFormat}
          selected={selected}
          onChange={onChange}
          disabled={disabled}
          calendarStartDay={1}
          customInput={<ExampleCustomInput />}
        />
      )}
    </label>
  );
};

export default InputDate;
